var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 29.0776C18.5851 29.5463 17.0722 29.8 15.5 29.8C7.60233 29.8 1.2 23.3977 1.2 15.5C1.2 7.60233 7.60233 1.2 15.5 1.2C23.3977 1.2 29.8 7.60233 29.8 15.5C29.8 16.0066 29.7737 16.507 29.7223 17H30.9284C30.9757 16.5064 31 16.006 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31C17.065 31 18.5758 30.7681 20 30.3367V29.0776Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 21H28.5V20C28.5 18.62 27.38 17.5 26 17.5C24.62 17.5 23.5 18.62 23.5 20V21H23C22.45 21 22 21.45 22 22V27C22 27.55 22.45 28 23 28H29C29.55 28 30 27.55 30 27V22C30 21.45 29.55 21 29 21ZM24.5 20C24.5 19.17 25.17 18.5 26 18.5C26.83 18.5 27.5 19.17 27.5 20V21H24.5V20ZM29 27H23V22H29V27ZM26 25.5C26.55 25.5 27 25.05 27 24.5C27 23.95 26.55 23.5 26 23.5C25.45 23.5 25 23.95 25 24.5C25 25.05 25.45 25.5 26 25.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7501 18.1274L10.6226 14.9999L9.55762 16.0574L13.7501 20.2499L22.7501 11.2499L21.6926 10.1924L13.7501 18.1274Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockCircle);
export default __webpack_public_path__ + "static/media/LockCircle.c2b102a550d11140f75af9d638fe2f04.svg";
export { ForwardRef as ReactComponent };